import React from 'react';
import { makeStyles } from '../styles';
const useStyles = makeStyles(({ spacing, palette }) => ({
    handle: {
        position: 'absolute',
        marginLeft: '-8px',
        marginTop: '-5px',
        zIndex: 2,
        width: spacing(2),
        height: spacing(2),
        cursor: 'pointer',
        borderRadius: '50%',
        border: `solid 1px ${palette.background.default}`,
        background: palette.secondary.main,
    },
}));
export function Handle({ domain: [min, max], handle: { id, value, percent }, key, getHandleProps, }) {
    const classes = useStyles();
    return (React.createElement("div", { key: key, role: "slider", "aria-valuemin": min, "aria-valuemax": max, "aria-valuenow": value, className: classes.handle, style: {
            left: `${percent}%`,
        }, ...getHandleProps(id) }));
}
//# sourceMappingURL=Handle.js.map